// ---------------------------------------------------------

import Component from './component';
import transform from './transformer';

// ---------------------------------------------------------

const ShareModal = (props) => <Component {...transform(props)} />;

export default ShareModal;

// ---------------------------------------------------------

export { Component as component, transform as transformer };
